import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'

interface LegalLayoutProps {
  title: string
  lastUpdated: string
  children: ReactNode
}

export function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  return (
    <main
      style={{
        font: '16px/1.6 system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
        maxWidth: 720,
        margin: '4rem auto',
        padding: '0 1.25rem',
      }}
    >
      <p>
        <Link to="/" style={{ color: '#2563eb' }}>
          ← Prism Factory
        </Link>
      </p>
      <h1 style={{ lineHeight: 1.25 }}>{title}</h1>
      <p style={{ color: '#666', fontSize: '0.9em' }}>Last updated: {lastUpdated}</p>
      {children}
    </main>
  )
}
